<div class="ion-padding">
  <div class="smtileitem-wrapper"
    [ngStyle]="{'background-image': 'url(' + safeURL(mediaUrl(b.image)) + ')'}">
  </div>
</div>